<div class="edit-block mat-elevation-z1">
    <h2>{{ 'bloc' | translate }}</h2>

    <mat-form-field color="primary">
        <input matInput
               #repeatNumber
               [formControl]="nbRepeatFormControl"
               type="number"
               [placeholder]="'nbRepeatBlocPlaceholder' | translate"
               autocomplete="off">
        <mat-error *ngIf="nbRepeatFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
        <mat-error *ngIf="nbRepeatFormControl.hasError('min')">{{ 'Min_value' | translate: { value: repeatMinValue } }}</mat-error>
    </mat-form-field>
</div>
